<template>
    <div class="flex gap-3">
        <div class="dx-field flex-1">
            <div class="dx-field-label">В платежных документах</div>
            <div class="dx-field-value">
                <ai-text-box :value="data.adres_pd_display" />
            </div>
        </div>
        <DxButton class="self-end" icon="preferences" hint="Сформировать строку адреса" />
    </div>
</template>

<script setup>
import { inject } from 'vue';
import DxButton from 'devextreme-vue/button';
import AiTextBox from '@/components/ai-text-box.vue';
const data = inject('serverData');
</script>

<style scoped>
.custom-field {
    display: flex;
    gap: 1rem;
}
.text-box {
    width: 0px;
    flex-grow: 1;
}
</style>
